export const configDisplayOptions = [
  {
    label: "Blood Pressure",
    readingKey: "bp",
    subTypes: [
      { key: "systolic", label: "Systolic" },
      { key: "diastolic", label: "Diastolic" }
    ]
  },
  {
    label: "Blood Glucose",
    readingKey: "bgl",
    subTypes: [
      { key: "glucose", label: "Glucose" }
    ]
  },
  {
    label: "Spirometry",
    readingKey: "spir",
    subTypes: [
      { key: "FEV1", label: "FEV1" },
      { key: "FVC", label: "FVC" },
      { key: "FEV1_FVC", label: "FEV1/FVC" },
      { key: "PEF", label: "PEF"}
    ]
  },
  {
    label: "Oxygen Saturation",
    readingKey: "spo2",
    subTypes: [
      { key: "spo2", label: "Oxygen Saturation" }
    ]
  },
  {
    label: "Heart Rate",
    readingKey: "hrt",
    subTypes: [
      { key: "pulse", label: "Pulse" }
    ]
  },
  {
    label: "Temperature",
    readingKey: "temp",
    subTypes: [
      { key: "temp", label: "Temperature"}
    ]
  },
  {
    label: "Weight",
    readingKey: "wt",
    subTypes: [
      { key: "wt", label: "Weight" }
    ]
  },
  {
    label: "Activity",
    readingKey: "activity",
    subTypes: [
      { key: "steps", label: "Activity" }
    ]
  },
  {
    label: "Sleep",
    readingKey: "sleep",
    subTypes: [
      { key: "sleep", label: "Sleep" }
    ]
  },
  {
    label: "Risk Alerts",
    readingKey: "riskAlerts",
    subTypes: [{ key: "riskAlerts", label: "Risk Alerts" }]
  },
  {
    label: "Last Measurement",
    readingKey: "lastMeasurement",
    subTypes: [{ key: "lastMeasurement", label: "Last Measurement" }]
  }
];